var map = {
	"./tech-responsive-apache-airflow.svg": 4193,
	"./tech-responsive-artificial-intelligence.svg": 4194,
	"./tech-responsive-azure.svg": 4195,
	"./tech-responsive-chatgpt.svg": 4196,
	"./tech-responsive-copilot.svg": 4197,
	"./tech-responsive-data.svg": 4198,
	"./tech-responsive-excel.svg": 4199,
	"./tech-responsive-git.svg": 4200,
	"./tech-responsive-google-cloud.svg": 4201,
	"./tech-responsive-google-sheets.svg": 4202,
	"./tech-responsive-hugging-face.svg": 4203,
	"./tech-responsive-jupyter.svg": 4204,
	"./tech-responsive-langchain.svg": 4205,
	"./tech-responsive-llama.svg": 4206,
	"./tech-responsive-multiple.svg": 4207,
	"./tech-responsive-powerbi.svg": 4208,
	"./tech-responsive-powerpoint.svg": 4209,
	"./tech-responsive-python.svg": 4210,
	"./tech-responsive-r.svg": 4211,
	"./tech-responsive-shell.svg": 4212,
	"./tech-responsive-sql.svg": 4213,
	"./tech-responsive-tableau.svg": 4214,
	"./tech-responsive-theory.svg": 4215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3854;